import { PreRequestFormState } from "../types";

export const initialState: PreRequestFormState = {
  estimatedBudget: undefined,
  organizationDescription: "",
  projectName: "",
  projectDescription: "",
  isBusy: false
};
